import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { TableAction, TableHeader, Tag } from '@huge-monorepo/shared/interfaces';
import { MatDialog } from '@angular/material/dialog';
import { TeltonikaEditTagModalComponent } from '../modals/teltonika-edit-tag-modal/teltonika-edit-tag-modal.component';
import { DialogService } from '@huge-monorepo/shared/services';
import { ToastrService } from 'ngx-toastr';
import { YesNoModalComponent } from '@huge-monorepo/shared/tools';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { TeltonikaCreateTagModalComponent } from '../modals/teltonika-create-tag-modal/teltonika-create-tag-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';
import {
  TeltonikaUpdateDeviceTagsModalComponent
} from '../modals/teltonika-update-device-tags-modal/teltonika-update-device-tags-modal.component';

@Component({
  selector: 'huge-monorepo-teltonika-tags',
  standalone: true,
  imports: [CommonModule, ToolsModule, MaterialModule],
  templateUrl: './teltonika-tags.component.html',
  styleUrl: './teltonika-tags.component.scss',
})
export class TeltonikaTagsComponent {
  teltonikaService = this.sharedTeltonikaService.getService();
  index: number = 0;
  selectedTags: Tag[] = [];
  displayCount: number = 10;
  displayTable: boolean = true;
  constructor(
    private dialog: MatDialog,
    private dialogService: DialogService,
    private toastr: ToastrService,
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private router: Router,
  ) { }

  headers: TableHeader[] = [
    {
      ID: 'Name',
      Index: this.index++,
      Sort: 'Name',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
    },

    {
      ID: 'Description',
      Index: this.index++,
      Sort: 'Description',
      Sortable: false,
      Text: 'Description',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'DeviceCount',
      Index: this.index++,
      Sort: 'DeviceCount',
      Sortable: false,
      Text: 'Devices',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'CreatedAt',
      Index: this.index++,
      Sort: 'CreatedAt',
      Sortable: false,
      Text: 'Created At',
      Type: Date,
      Align: 'left',
    },
  ];

  actions: TableAction[] = [
    {
      Icon: 'edit_square',
      Text: 'Edit',
      Caller: (p: Tag) => {
        this.openEditModal(p);
      },
    },
    {
      Icon: 'library_add',
      Text: 'Manage Devices',
      Caller: (p: Tag) => {
        this.router.navigate(['Teltonika', 'Tags', p.ID]);
      },
    },
    {
      Icon: 'delete',
      Text: 'Delete',
      Caller: (p: Tag) => {
        this.openConfirmationModal(p);
      },
    },
    {
      Icon: 'assignment_ind',
      Text: 'Assign Devices',
      Caller: (p: Tag) => this.openUpdateTeltonikaDeviceTags(),
    },
  ];

  addSelected(e: Tag[]) {
    this.selectedTags = e;
  }

  async openEditModal(p: Tag) {
    const dialogRef = this.dialog.open(TeltonikaEditTagModalComponent, {
      width: '500px',
      height: '90vh',
      data: {
        Description: p.Description,
        Emails: p.DeviceStatusUpdateEmail,
        Name: p.Name,
      },
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);

      if (result != null) {
        if (result.Description === null) {
          return;
        } else {
          this.displayTable = false;

          this.teltonikaService.upsertTag(p.ID, result.Description, result.Emails, p.Name).subscribe({
            next: (resp) => {
              this.toastr.success('Tag Updated');
              this.displayTable = true;
            },
            error: (err) => {
              this.toastr.error('Error Updating Tag');
            },
          });
        }
      }
    });
  }

  openConfirmationModal(p: Tag) {
    const dialogRef = this.dialog.open(YesNoModalComponent, {
      width: '500px',
      data: {
        Heading: 'Delete Tag',
        Message: 'Are you sure you want to delete this tag?',
      },
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result != null) {
        if (result) {
          this.displayTable = false;

          this.teltonikaService.deleteTag(p.ID).subscribe({
            next: (resp) => {
              this.toastr.success('Tag Deleted');
              this.displayTable = true;
            },
            error: (err) => {
              this.toastr.error('Error Deleting Tag');
            },
          });
        }
      }
    });
  }

  createTag() {
    const dialogRef = this.dialog.open(TeltonikaCreateTagModalComponent, {
      width: '500px',
      height: '90vh',
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result != null) {
        if (result != false) {
          this.displayTable = false;
          this.teltonikaService.upsertTag(0, result.Description, result.Emails, result.Name).subscribe({
            next: (resp) => {
              this.toastr.success('Tag Created');
              this.displayTable = true;
            },
            error: (err) => {
              this.toastr.error('Error Creating Tag');
            },
          });
        }
      }
    });
  }

  async openUpdateTeltonikaDeviceTags(): Promise<void> {
    const dialogRef = this.dialog.open(TeltonikaUpdateDeviceTagsModalComponent, {
      width: '50vw',
      height: '70vh',
    });
    this.dialogService.RegisterDialog(dialogRef);
  }
}
